import {
    IonCol,
    IonCard,
  IonContent,
  IonGrid,
  IonHeader,
  IonPage,
  IonRow,
  IonTitle,
  IonToolbar,
  IonCardContent,
  IonLabel,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonList,
  IonItem,
  IonListHeader,
  IonItemDivider,
  IonIcon,
  IonImg,
  IonModal,
  IonCheckbox,
  IonButtons,
  IonButton,
  useIonAlert,
  isPlatform,
  getPlatforms,
  IonRadio,
} from '@ionic/react';
import './Home.css';
import YouTube from 'react-youtube-embed';
import { RouteComponentProps } from 'react-router';
import { checkmarkOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';

export const URL = (relativePath: string) => {
    const basePath = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? '' : '/ReportACrime';
    return `${basePath}${relativePath}`;
}

const crimes = [
    //{
    //    image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103391043673657465/DaveUlbrich_man_stealing_bicycles_from_road_vector_art_illustra_672fde23-0ec7-4941-a83b-6ce90127e0fc.png?ex=660da2fc&is=65fb2dfc&hm=3f787dbc8d179e1358fb06b2e33b1674825ab5f5a3611864e323f2f6c4d75db6&",
    //    title: "Bicycle Theft",
    //    description: "The act of stealing a bicycle without the owner's consent or knowledge.",
    //    link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1",
    //    video: ""
    //},
    {
        image: URL("/assets/icon/credit-card-fraud.png"),
        title: "Credit Card Fraud",
        description: "Credit card fraud is the unauthorized use of another person's credit card information to make purchases or obtain funds.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300018307",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300018307/es",
        video: ""
    },
    {
        image: URL("/assets/icon/damaged-property.png"),
        title: "Damaged Property",
        description: "Property damage that would be reported to the police includes vandalism, and any intentional or accidental destruction.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300018310",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300018310/es",
        video: ""
    },
    {
        image: URL("/assets/icon/found-property.png"),
        title: "Found Property",
        description: "Lost property items discovered by someone who is not the owner, and it should be turned in to help locate the owner.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300018277",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300018277/es",
        video: ""
    },
    {
        image: URL("/assets/icon/fraud.png"),
        title: "Fraud",
        description: "Fraud is a deliberate deception for financial or personal gain. It involves false representation, concealment, or failure to disclose.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300018305",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300018305/es",
        video: ""
    },
    {
        image: URL("/assets/icon/hit-and-run.png"),
        title: "Hit and Run",
        description: "Hit and run is a traffic accident where a driver involved fails to stop and provide their information or aid to others involved.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300017988",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300017988/es",
        video: ""
    },
    {
        image: URL("/assets/icon/identity-theft.png"),
        title: "Identity Theft",
        description: "Identity theft is where personal information is stolen and used without permission to commit fraud or other illegal activities.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300017989",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300017989/es",
        video: ""
    },
    {
        image: URL("/assets/icon/lost-property.png"),
        title: "Lost Property",
        description: "Lost property is any item that has been misplaced or left behind by its owner, with no known location or immediate recovery.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300017990",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300017990/es",
        video: ""
    },
    {
        image: URL("/assets/icon/telephone-electronic-harassment.png"),
        title: "Telephone / Electronic Communication Harassment",
        description: "Unwanted harassing communication using electronic devices.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300017987",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300017987/es",
        video: ""
    },
    {
        image: URL("/assets/icon/minor-vehicle-accidents.png"),
        title: "Minor Vehicle Accidents",
        description: "Traffic accidents are incidents that occurs when vehicles or pedestrians collide, resulting in property damage or injuries.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300017991",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300017991/es",
        video: "AIcrQw2j-jQ"
    },
    {
        image: URL("/assets/icon/trespassing.png"),
        title: "Trespassing",
        description: "Trespassing is the act of entering on someone else's property without their permission. It is a civil or criminal offense.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300018304",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300018304/es",
        video: ""
    },
    {
        image: URL("/assets/icon/theft-of-property.png"),
        title: "Theft of Property",
        description: "Theft of property is the act of taking someone else's belongings without their permission, depriving the owner of its use or value.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300017992",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300017992/es",
        video: ""
    },
    //{
    //    image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103480359632515082/DaveUlbrich_cartoon_hand_full_of_money_blue_themed_e7d77c91-8d3b-47c4-b702-c4efbbea1a77.png?ex=660df62b&is=65fb812b&hm=f323e31d6ab00b182a9cb15c7ece03aab1e41789351f1690c198cb756cb5886f&",
    //    title: "Theft of Services",
    //    description: "Theft of services is the act of obtaining and using services without paying, with the intent to deprive the provider of its value.",
    //    link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1",
    //    video: ""
    //},
    {
        image: URL("/assets/icon/vandalism-not-to-vehicle.png"),
        title: "Vandalism (not to vehicle)",
        description: "Vandalism is the deliberate and malicious destruction, damage, or defacement of property belonging to someone else",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300017993",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300017993/es",
        video: ""
    },
    {
        image: URL("/assets/icon/vehicle-burglary.png"),
        title: "Vehicle Burglary",
        description: "Vehicle burglary is the act of illegally entering and stealing from a car or other motor vehicle.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300017994",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300017994/es",
        video: ""
    },
    //{
    //    image: "https://cdn.discordapp.com/attachments/1094992266503913532/1109186990819258582/DaveUlbrich_running_away_illustration_with_blue_theme_b9c23e61-8245-40e0-bf8c-6ec2030f76e5.png?ex=66070962&is=65f49462&hm=d7dc24a60986ff51395efaa2fc572f5cdd34cd67f0d524b1594fdb714b49bff8&",
    //    title: "Vulnerable Individual Registy",
    //    description: "Regestry for vulnerable individuals that may wander or run.",
    //    link: "https://orem.org/mhrt/",
    //    video: ""
    //},
    {
        image: URL("/assets/icon/abandoned-vehicle.png"),
        title: "Abandoned Vehicle",
        description: "Report a vehicle that has not moved within 72 hours from being parked in the same spot on the roadway.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300023802/en",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300023802/es",
        video: ""
    },
    {
        image: URL("/assets/icon/documentation-only.png"),
        title: "Documentation Only",
        description: "Fill out a statement form on any subject matter they would like documented with the police department.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300018308",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300018308/es",
        video: ""
    },
    {
        image: URL("/assets/icon/extra-patrol-request.png"),
        title: "Extra Patrol Request",
        description: "A specific incident or pattern requires additional patrol in an area witin Orem.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300018309",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300018309/es",
        video: ""
    },
    {
        image: URL("/assets/icon/traffic-complaints.png"),
        title: "Traffic Complaints",
        description: "A vehicle has a pattern of driving dangerously or has a pattern of repeatedly driving unsafely.",
        link: "https://secure.coplogic.com/dors/startreport/300008266/300018303",
        spanishLink: "https://secure.coplogic.com/dors/startreport/300008266/300018303/es",
        video: ""
    },
]

const crimesReal = [
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103685454630498324/DaveUlbrich_bike_theft_4b3f8c76-7189-4495-beef-26a9c0a9576f.png",
        title: "Bicycle Theft",
        description: "The act of stealing a bicycle without the owner's consent or knowledge.",
        link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1"
    },
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103686232485146624/DaveUlbrich_credit_cards_d24a1a47-ba61-43f6-9a65-8e327eecf258.png",
        title: "Credit Card Fraud",
        description: "Credit card fraud is the unauthorized use of another person's credit card information to make purchases or obtain funds.",
        link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1"
    },
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103486555785531462/DaveUlbrich_cartoon_of_damaged_property_e83c7493-e21f-47c3-b863-523177d334a2.png?ex=660dfbf0&is=65fb86f0&hm=5871f3d05cec032df238c10b4466a689abe0f5bf415fa2254a1da5f9321985be&",
        title: "Damaged Property",
        description: "Property damage that would be reported to the police includes vandalism, arson, and any intentional or accidental destruction.",
        link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1"
    },
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103687527744933888/DaveUlbrich_lost_wallet_9db4d0c0-c878-46b9-91b2-59ba5dadd82d.png",
        title: "Found Property",
        description: "Lost property items discovered by someone who is not the owner, and it should be turned in to help locate the owner.",
        link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1"
    },
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103687909019746355/DaveUlbrich_fraud_22484277-f9f4-4898-be64-7eb5c1677bc1.png",
        title: "Fraud",
        description: "Fraud is a deliberate deception for financial or personal gain. It involves false representation, concealment, or failure to disclose.",
        link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1"
    },
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103688331985961000/DaveUlbrich_broken_car_window_ce24ec28-5abf-4913-b4ee-012c3e70303b.png",
        title: "Hit and Run",
        description: "Hit and run is a traffic accident where a driver involved fails to stop and provide their information or aid to others involved.",
        link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1"
    },
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103688877157388308/DaveUlbrich_drivers_licenses_c1011855-1998-44f1-9efa-92bae1ff207c.png",
        title: "Identity Theft",
        description: "Identity theft is where personal information is stolen and used without permission to commit fraud or other illegal activities.",
        link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1"
    },
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103689682904162344/DaveUlbrich_lost_belongings_knolling_06b9e3d8-0c9c-4e26-9d95-b3d4bd4508c9.png",
        title: "Lost Property",
        description: "Lost property is any item that has been misplaced or left behind by its owner, with no known location or immediate recovery.",
        link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1"
    },
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103690245062537278/DaveUlbrich_mobile_phone_tablet_laptop_knolling_353157c0-bfd1-4782-87ee-cd513becefcb.png",
        title: "Telephone/Electronic Communication Harassment",
        description: "Unwanted harassing communication using electronic devices.",
        link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1"
    },
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103691008136445952/DaveUlbrich_traffic_accident_387d4e16-bb7d-4cf1-8ec7-67f443927ff3.png",
        title: "Traffic Accident",
        description: "Traffic accidents are incidents that occurs when vehicles or pedestrians collide, resulting in property damage or injuries.",
        link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1"
    },
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103691664847011900/DaveUlbrich_chain_link_fench_in_front_of_restricted_area_7f8b86ab-da8a-40b8-b279-481ba4cc55dc.png",
        title: "Trespassing",
        description: "Trespassing is the act of entering on someone else's property without their permission. It is a civil or criminal offense.",
        link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1"
    },
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103692587220615278/DaveUlbrich_thieves_carrying_boxes_4f4abed2-4368-4791-ae24-2642e5028156.png",
        title: "Theft of Property",
        description: "Theft of property is the act of taking someone else's belongings without their permission, depriving the owner of its use or value.",
        link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1"
    },
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103693072765833216/DaveUlbrich_handfulls_of_cash_4e7048e7-23a0-4c85-86c1-e0ad8b393afd.png",
        title: "Theft of Services",
        description: "Theft of services is the act of obtaining and using services without paying, with the intent to deprive the provider of its value.",
        link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1"
    },
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103693528867020873/DaveUlbrich_graffiti_on_a_brick_wall_ce191742-843f-4edf-98d5-3165812d22d0.png",
        title: "Vandalism",
        description: "Vandalism is the deliberate and malicious destruction, damage, or defacement of property belonging to someone else",
        link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1"
    },
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1103694883979538553/DaveUlbrich_night_surveilance_camera_footage_of_someone_breakin_a41afd96-5c1e-4c80-b5a3-43f1f88f01be.png",
        title: "Vehicle Burglary",
        description: "Vehicle burglary is the act of illegally entering and stealing from a car or other motor vehicle.",
        link: "https://secure.coplogic.com/dors/en/filing/submitreport?dynparam=1683130606900#additionalInfoAnchor1"
    },
    {
        image: "https://cdn.discordapp.com/attachments/1094992266503913532/1109186794026717244/DaveUlbrich_running_away_188601a4-1a3b-4354-8659-c1bf219be9b7.png",
        title: "Vulnerable Individual Registy",
        description: "Regestry for vulnerable individuals that may wander or run.",
        link: "https://orem.org/mhrt/"
    },
]

const instructions = [
    {
        instruction: "Requirements for online reporting:",
        points: [
            "If this incident occurred on any property owned or maintained by UVU please contact the UVU Police Department 801-863-5555."
        ]
    },
    {
        instruction: "Please make sure to turn off your pop-up blocking software before filing the report.",
        points: []
    },
    {
        instruction: "Upon completion of this report process you will:",
        points: [
            `See the words: "Your online police report has been submitted" showing that your police report is complete.`,
            "Be given a police report case number.",
            "Be able to print a copy of the police report to keep for your records."
        ]
    },
    {
        instruction: "Please Note:",
        points: [
            "All cases filed using the Online Reporting System will be reviewed.",
            "Upon review, if further investigation of your case is needed, you may be contacted.",
            "Filing a false police report is a crime."
        ]
    },
    {
        instruction: "When selecting an incident type, please be sure to review the entire list with definitions and examples on the following page to select the most appropriate one.",
        points: []
    },
    {
        instruction: "If your incident is not listed in the category selection list, please call the Orem City Police Department (emergency 9 - 1 - 1; non- emergency 801 - 852 - 6210) to file your report.",
        points: []
    },
    {
        instruction: "Select one of the following incidents to report:",
        points: []
    }
]

declare global {
    interface Window {
        google: any;
        googleTranslateElementInit: () => void;
    }
}

interface HomeProps extends RouteComponentProps<{ version: string }> { }

const Home: React.FC<HomeProps> = ({ match }) => {
    const platforms = getPlatforms();
    const isDesktop = !(platforms.includes("ios") || platforms.includes("android"));
    const [showAcknowledgementModal, setShowAcknowledgementModal] = useState(false);
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [videoId, setVideoId] = useState("");
    const [acknowledgementChecked, setAcknowledgementChecked] = useState(false);
    const [crimeLink, setCrimeLink] = useState("");
    const [crimeSpanishLink, setCrimeSpanishLink] = useState("");
    const [presentAcknowledgementAlert] = useIonAlert();
    const googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
            {
                pageLanguage: "en",
                autoDisplay: false
            },
            "google_translate_element"
        );
    };
    useEffect(() => {
        var addScript = document.createElement("script");
        addScript.setAttribute(
            "src",
            "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
        );
        document.body.appendChild(addScript);
        window.googleTranslateElementInit = googleTranslateElementInit;
    }, []);
    const handleShowVideo = (videoId: string) => {
        setVideoId(videoId);
        setShowVideoModal(true);
    }
    return (
        <IonPage id="home-page">
            <IonHeader>
                <IonToolbar color="primary">
                    <IonTitle>Orem Police Department</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen color="light">
                <IonGrid>
                    <IonRow>
                        <IonCol size="0" sizeLg="2"></IonCol>
                        <IonCol>
                            <IonImg src={URL("/assets/icon/reporting.png")} style={{height: "180px"}} />
                        </IonCol>
                        <IonCol size="0" sizeLg="2"></IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size="0" sizeLg="5.5"></IonCol>
                        <IonCol>
                            <div id="google_translate_element"></div>
                        </IonCol>
                        <IonCol size="0" sizeLg="5.5"></IonCol>
                    </IonRow>
                    {/*<IonRow>*/}
                    {/*    <IonCol size="0" sizeLg="2.5"></IonCol>*/}
                    {/*    <IonCol>*/}
                    {/*        <IonCard>*/}
                    {/*            <IonCardContent className="ion-no-padding">*/}
                    {/*                <YouTube id="Ahiuu1wvBfs" />*/}
                    {/*            </IonCardContent>*/}
                    {/*        </IonCard>*/}
                    {/*    </IonCol>*/}
                    {/*    <IonCol size="0" sizeLg="2.5"></IonCol>*/}
                    {/*</IonRow>*/}
                    <IonRow>
                        <IonCol size="12" sizeLg="4">
                            <IonCard mode="md" color="primary" style={{ height: isDesktop ? "650px" : "600px" }}>{ }
                                <IonCardHeader>
                                    <IonCardTitle>If you can answer <strong>YES</strong> to all of the below questions, you are ready to file your report online.</IonCardTitle>
                                </IonCardHeader>
                                <IonCardContent>
                                    <IonList className="ion-no-padding">
                                        <IonItem color="primary">
                                            <IonIcon icon={checkmarkOutline} slot="start" />
                                            <IonLabel className="ion-text-wrap">This is not an Emergency?</IonLabel>
                                        </IonItem>
                                        <IonItem color="primary">
                                            <IonIcon icon={checkmarkOutline} slot="start" />
                                            <IonLabel className="ion-text-wrap">This incident occurred within the Orem City jurisdiction?</IonLabel>
                                        </IonItem>
                                        <IonItem color="primary">
                                            <IonIcon icon={checkmarkOutline} slot="start" />
                                            <IonLabel className="ion-text-wrap">This did not occur on a state highway?</IonLabel>
                                        </IonItem>
                                        <IonItem color="primary">
                                            <IonIcon icon={checkmarkOutline} slot="start" />
                                            <IonLabel className="ion-text-wrap">You have a current email address, that you check regularly, to find out if additional information is required or your report has been accepted.</IonLabel>
                                        </IonItem>
                                        <IonItem lines="none" color="primary">
                                            <IonLabel className="ion-text-wrap">If you answered NO to any of the questions please do not submit a report.</IonLabel>
                                        </IonItem>
                                    </IonList>
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                        <IonCol>
                            <IonCard mode="md" style={{ height: isDesktop ? "650px" : "950px" }}>
                                <IonCardHeader color="warning">
                                    <IonCardSubtitle>Please Follow</IonCardSubtitle>
                                    <IonCardTitle>Instructions</IonCardTitle>
                                </IonCardHeader>
                                <IonCardContent className="ion-no-padding">
                                    <div className="ion-padding">
                                        {instructions.map((instruction: any) => (
                                            <>
                                                <p><strong>{instruction.instruction}</strong></p>
                                                <ul>
                                                    {instruction.points.map((point: string) => (
                                                        <li>{point}</li>
                                                    ))}
                                                </ul>
                                            </>
                                        ))}
                                    </div>
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonCard color="danger" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <IonCardContent>
                                    <IonLabel>IF THIS IS AN EMERGENCY CALL 911</IonLabel>
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        {match.params.version === '1' && (
                            <>
                                {crimes.map((crime: any) => (
                                    <IonCol size="12" sizeXl="1.5">
                                        <IonCard
                                            mode="md"
                                            onClick={() => { setCrimeLink(crime.link); setCrimeSpanishLink(crime.spanishLink); crime.video === "" ? setShowAcknowledgementModal(true) : handleShowVideo(crime.video) }}
                                            style={{height: "400px"}}
                                        >
                                            <img alt={crime.title} src={crime.image} />
                                            <IonCardHeader>
                                                <IonCardTitle>{crime.title}</IonCardTitle>
                                            </IonCardHeader>
                                            <IonCardContent>
                                                {crime.description}
                                            </IonCardContent>
                                        </IonCard>
                                    </IonCol>
                                ))}
                            </>
                        )}
                        {match.params.version === '2' && (
                            <>
                                {crimesReal.map((crime: any) => (
                                    <IonCol size="12" sizeXl="1.5">
                                        <IonCard
                                            mode="md"
                                            onClick={() => { setCrimeLink(crime.link); setCrimeSpanishLink(crime.spanishLink); setShowAcknowledgementModal(true); }}
                                            style={{ height: "400px" }}
                                        >
                                            <img alt={crime.title} src={crime.image} />
                                            <IonCardHeader>
                                                <IonCardTitle>{crime.title}</IonCardTitle>
                                            </IonCardHeader>
                                            <IonCardContent>
                                                {crime.description}
                                            </IonCardContent>
                                        </IonCard>
                                    </IonCol>
                                ))}
                            </>
                        )}
                    </IonRow>
                </IonGrid>
                <IonModal isOpen={showVideoModal} onIonModalDidDismiss={() => { setShowVideoModal(false); }}>
                    <IonToolbar color="danger">
                        <IonTitle>Watch First</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={() => setShowVideoModal(false)}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                    <IonContent>
                        {videoId !== "" && (<YouTube id={videoId} />)}
                        <IonList>
                            <IonItem onClick={() => { setShowVideoModal(false); setShowAcknowledgementModal(true); }}>
                                <IonCheckbox slot="start" />
                                <IonLabel className="ion-text-wrap">I acknowledge that I have watched and understood this video.</IonLabel>
                            </IonItem>
                        </IonList>
                    </IonContent>
                </IonModal>
                <IonModal isOpen={showAcknowledgementModal} onIonModalDidDismiss={() => { setShowAcknowledgementModal(false); setAcknowledgementChecked(false); }}>
                    <IonToolbar color="danger">
                        <IonTitle>Statement of Truth and Accuracy</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={() => setShowAcknowledgementModal(false)}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                    <IonContent>
                        <IonList>
                            <IonItem lines="none" >
                                <IonCheckbox
                                    slot="start"
                                    checked={acknowledgementChecked}
                                    onClick={() => setAcknowledgementChecked(!acknowledgementChecked)} />
                                <IonLabel className="ion-text-wrap">I hereby certify that all of the information that I have provided in this report is, to the best of my knowledge, accurate and true. I hereby aggree to assist the police in all investigation and prosecution which may result from the information contained in this report. I hereby certify that I am aware that the information I provide in this report may be presented to a magistrate or judge in lieu of my sworn testimony at a preliminary examination and may be called upon to testify in court.</IonLabel>
                            </IonItem>
                            <IonItem lines="none">
                                <IonLabel className="ion-text-wrap"><em><strong> I understand that it is a crime to knowingly provide false information in this online report according to Utah Code Annotated 76-8-506.</strong></em></IonLabel>
                            </IonItem>
                        </IonList>
                        <IonButton
                            expand="block"
                            className="ion-padding"
                            onClick={() => {
                                if (acknowledgementChecked === false) {
                                    presentAcknowledgementAlert({
                                        header: "Attention!",
                                        message: "You must click the checkbox to cirtify the truth and accuracy of the report you file before you can continue to the report.",
                                        buttons: ["OK"]
                                    })
                                } else {
                                    setShowAcknowledgementModal(false);
                                    window.open(crimeLink, '_blank');
                                }
                            }}
                        >
                            Continue to report
                        </IonButton>
                        <IonButton
                            expand="block"
                            className="ion-padding"
                            onClick={() => {
                                if (acknowledgementChecked === false) {
                                    presentAcknowledgementAlert({
                                        header: "Attention!",
                                        message: "You must click the checkbox to cirtify the truth and accuracy of the report you file before you can continue to the report.",
                                        buttons: ["OK"]
                                    })
                                } else {
                                    setShowAcknowledgementModal(false);
                                    window.open(crimeSpanishLink, '_blank');
                                }
                            }}
                        >
                            Continue to report (In Spanish)
                        </IonButton>
                    </IonContent>
                </IonModal>
            </IonContent>
        </IonPage>    
    );
};

export default Home;
